module.exports = __webpack_public_path__ + "static/img/brees-2010-slide-7.4257c3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-slide-7.jpg
// module id = Ao7i
// module chunks = 1